import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";
import { floatOnly } from "../../../../utils";

export default function WebNumeracyInputText({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [answerBox, setAnswerBox] = useState(data.answerBox);
    const [answer, setAnswer] = useState({});

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setAnswerBox(data.answerBox);
        setAnswer({});
    }, [question,
        data.answerBox,
    ]);

    const handleChangeAnswer = (ans, e) => {
        const value = e.target.value;
       
        if (floatOnly(value) || value === "") {
            // we will proceed to answer
            let currentAnswer = {...answer};
            currentAnswer[ans.stateKey] = value;
            setAnswer(currentAnswer);
            checkCanProceed(currentAnswer);

        }
    }

    const checkCanProceed = (ans) => {
        let canProceed = false;
        const answerKeys = Object.keys(ans);
        answerKeys.map((keys) => {
            if (ans[keys] !== "" && ans[keys] !== null) {
                canProceed = true;   
            }
            return null;
        });

        onAnswer({
            canProceed,
            answer: ans,
        });
    }

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
            }}
        >
            <Box component="img"
                src={`${imagesResources}${data.image}`}
                sx={{
                    marginRight: "10px",
                }}
                alt="Img"
            />

            {/* For Answer Box */}
            <Box sx={{
                borderBottom: "10px solid #308337",
                textAlign: "center",
            }}>
                <Box sx={{
                    fontWeight: "bold",
                    backgroundColor: "#40AE49",
                    color: "black",
                    borderBottomWidth: "10px",
                    borderBottomStyle: "solid",
                    borderBottomColor: "#308337",
                    padding: "8px",
                    paddingRight: "20px",
                    fontSize: "1.25em",
                    textAlign: "left",
                }}>{data.answerBoxHeader}</Box>

                <Box sx={{
                    display: "grid",
                    gridTemplateColumns: "100px 1fr",
                    alignItems: "center",
                    gap: "10px",
                    backgroundColor: "#f2f2f2",
                    padding: "10px",
                    textAlign: "center",
                }}>
                    {answerBox.map((ans, index) => (
                        <React.Fragment key={index}>
                            <Box component="span"
                                sx={{
                                    fontWeight: "bold",
                                    fontSize: "20px",
                                    textAlign: "center"
                                }}
                            >{ans.value}</Box>
                            <Box sx={{
                                position: "relative",
                                textAlign: "center",
                            }}>
                                <input type="text"
                                    value={answer[ans.stateKey] ?? ''}
                                    style={{
                                        width: "200px",
                                        boxSizing: "border-box",
                                        height: "2em",
                                        outline: "none",
                                        border: "none",
                                        borderBottom: "2px solid #888888",
                                        padding: "0.5em 1em",
                                        fontSize: "1.5em",
                                        textAlign: "left",
                                    }}
                                    onChange={(e) => {handleChangeAnswer(ans, e)}}
                                />
                            </Box>
                        </React.Fragment>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};